export const toDateString = (isoString: string): string => {
  const date = new Date(isoString);

  return date.toLocaleDateString();
};
